import { render, staticRenderFns } from "./manage-integration-service-layout.vue?vue&type=template&id=f70e04c0&scoped=true"
import script from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
export * from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
import style0 from "./manage-integration-service-layout.vue?vue&type=style&index=0&id=f70e04c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70e04c0",
  null
  
)

export default component.exports